import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostBinding,
  Input
} from '@angular/core';
import { I18nService } from '@ppl/i18n';
import QRCode from 'qrcode';
import type {
  AfterViewInit,
  OnChanges
} from '@angular/core';
import { notFirstChange, type TSimpleChanges } from '@ppl/utils/angular.utils';

@Component({
  selector: 'ppl-qr-code',
  standalone: false,
  templateUrl: './qr-code.component.html',
  styleUrl: './qr-code.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class QrCodeComponent implements OnChanges, AfterViewInit {

  @Input() size: number;
  @Input() @HostBinding('style.width.px') @HostBinding('style.height.px') value: string;

  constructor(
    private elementRef: ElementRef,
    private i18nService: I18nService
  ) { }

  ngOnChanges(changes: TSimpleChanges<QrCodeComponent>) {
    if (!notFirstChange(changes.size) || !notFirstChange(changes.value)) {
      this.renderCode();
    }
  }

  ngAfterViewInit() {
    this.renderCode();
  }

  renderCode() {
    QRCode.toCanvas(this.value, { width: this.size, margin: 2 }, (error, canvas) => {
      this.elementRef.nativeElement.innerHTML = '';

      if (error) {
        console.error('Generating QR Code failed.', error);
        this.elementRef.nativeElement.innerHTML = this.i18nService.translate('Generating_QR_Code_failed.');
      } else {
        this.elementRef.nativeElement.appendChild(canvas);
      }
    });
  }

}
